import * as TrackAPI from "../api/track";
import * as DummyTrackAPI from "../dummyApi/track";
import { isDemoMode } from "../stores/mode";

interface TrackApi {
  trackSiteVisit: () => void;
}

const getAPI = (): TrackApi => {
  return isDemoMode()
    ? DummyTrackAPI
    : TrackAPI;
};

export const trackSiteVisit = () => getAPI().trackSiteVisit();
